export const EAGLE_EYE_IS_DOWN_MESSAGE =
  'Live video streaming is currently not available. Please try again later.';

export const LINKED_ACTIONS_FOR_DOORS_LOG = [
  {
    label: 'Deliveries',
    value: 'delivery',
  },
  {
    label: 'Visitors',
    value: 'visitor_buzz_in',
  },
  {
    label: 'Residents',
    value: 'person_buzz_in',
  },
];

export const METHODS_FOR_DOORS_LOG = [
  {
    label: '24/7 Remote Doorman',
    value: 'call_center',
  },
  {
    label: 'Carson App',
    value: 'carson_app',
  },
  {
    label: 'Text Message',
    value: 'text_code',
  },
  {
    label: 'Web App',
    value: 'web_admin',
  },
  {
    label: 'FOB/Access Card',
    value: 'fob',
  },
  {
    label: 'Carson App BT',
    value: 'carson_app_bt',
  },
  {
    label: 'Concierge',
    value: 'consierge', // there is a typo on the backend, using the correct word won't work
  },
];

export const USA_ID = 893;

export const FLOW_BUILDINGS_IDS = [
  18496, // SLO prod
  10367, // SLO release
];
